const styles = (theme) => ({
  dialogPaper: {
    borderRadius: "16px",
  },
  dialogTitle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: 2,
  },
  titulo: {
    fontSize: "18px",
    fontWeight: 600,
  },
  subtitulo: {
    fontSize: "0.8rem",
    color: theme.palette.text.secondary,
  },
  content: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
    "&.MuiDialogContent-root": { pt: 1 },
  },
  actions: {
    padding: theme.spacing(2, 3, 3),
  },
});

export default styles;
